var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 88,
    viewBox: "0 0 64 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H46.1855C46.5771 0.5 46.9532 0.653173 47.2334 0.926789L63.048 16.3692C63.337 16.6515 63.5 17.0384 63.5 17.4424V86C63.5 86.8284 62.8284 87.5 62 87.5H2C1.17157 87.5 0.5 86.8284 0.5 86V2Z",
    fill: "#F0F3FA",
    stroke: "#E3E9F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 17V0H48.1716C48.702 0 49.2107 0.210714 49.5858 0.585786L63.4142 14.4142C63.7893 14.7893 64 15.298 64 15.8284V18H47C46.4477 18 46 17.5523 46 17Z",
    fill: "#BDC9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49.1818V39H25.7415V40.7749H21.1527V43.201H25.294V44.9759H21.1527V49.1818H19Z",
    fill: "#616A7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3422 39V49.1818H27.1895V39H29.3422Z",
    fill: "#616A7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1133 49.1818V39H33.266V47.407H37.631V49.1818H31.1133Z",
    fill: "#616A7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0566 49.1818V39H45.9174V40.7749H41.2093V43.201H45.5645V44.9759H41.2093V47.407H45.9373V49.1818H39.0566Z",
    fill: "#616A7D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1169903f878a43bc19217e14de650a13.svg";
export { ForwardRef as ReactComponent };